import * as WalletActions from "../actions/wallet_actions";
import { State, Actions } from "~/context/wallet_context/constants";
import { exhaustiveMatchGuard } from "~/actions/utils";

const wallet_reducer = (state: State, action: Actions) => {
  switch (action.type) {
    case WalletActions.SET_ADDRESS_BEGIN: {
      return {
        ...state,
        addressLoading: false,
        addressError: false,
      };
    }
    case WalletActions.SET_ADDRESS_SUCCESS: {
      const payload = action.payload;
      return {
        ...state,
        addressLoading: false,
        address: payload.address,
        wallet: payload.wallet,
        net: payload.net,
        blockchain: payload.blockchain,
        addressError: false,
      };
    }

    case WalletActions.SET_ADDRESS_ERROR: {
      return {
        ...state,
        addressLoading: false,
        addressError: false,
      };
    }
    case WalletActions.RECONNECT_BEGIN: {
      return {
        ...state,
        reconnectLoading: true,
        reconnectError: false,
      };
    }
    case WalletActions.RECONNECT_SUCCESS: {
      const payload = action.payload;
      return {
        ...state,
        reconnectLoading: false,
        address: payload.address,
        wallet: payload.wallet,
        net: payload.net,
        blockchain: payload.blockchain,
        reconnectError: false,
      };
    }

    case WalletActions.RECONNECT_ERROR: {
      return {
        ...state,
        reconnectLoading: false,
        reconnectError: true,
      };
    }
    case WalletActions.SIGN_TXN_BEGIN: {
      return {
        ...state,
        signingLoading: true,
        signingError: false,
      };
    }
    case WalletActions.SIGN_TXN_SUCCESS: {
      return {
        ...state,
        signingLoading: false,
        signingError: false,
      };
    }
    case WalletActions.SIGN_TXN_ERROR: {
      return {
        ...state,
        signingLoading: false,
        signingError: true,
      };
    }
    default: {
      // This will cause a typescript error if we haven't included every action in the switch statement
      return exhaustiveMatchGuard(action.type);
    }
  }
};

export default wallet_reducer;
